// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function jamaicaOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'jm',
    phone_number: userInputValues['jamaicaPhoneNumber'],
  };
}
